const defaultFedGateway = process.env.VUE_APP_FED_GATEWAY || 'https://apollo-platform-gateway.mercafacil.com/graphql'

export const microservicesUrls = {
  // upload
  upload: process.env.VUE_APP_GRAPHQL_UPLOAD || 'https://hulk.mercafacil.com/graphql',
  sales: process.env.VUE_APP_MICROSERVICES_SALES_HTTP || defaultFedGateway,
  cashback: process.env.VUE_APP_MICROSERVICES_CASHBACK_HTTP || defaultFedGateway,
  // upload
  cashbackUpload: process.env.VUE_APP_MICROSERVICES_CASHBACK_UPLOAD || 'https://cashback-microservice.mercafacil.com/graphql',
  campaigns: process.env.VUE_APP_MICROSERVICES_CAMPAIGNS_HTTP || defaultFedGateway,
  asyncJobs: process.env.VUE_APP_ASYNC_JOBS_HTTP || defaultFedGateway,
  // upload
  asyncJobsUpload: process.env.VUE_APP_ASYNC_JOBS_UPLOAD_HTTP || 'https://async-jobs-microservice.mercafacil.com/graphql',
  mfLogin: process.env.VUE_APP_SINGLE_LOGIN_URL || 'https://test-login.mercafacil.com:3333/#/',
  fedGateway: defaultFedGateway,
  // upload
  products: process.env.VUE_APP_MICROSERVICES_PRODUCTS_UPLOAD || 'https://prod-mng-svc.mercafacil.com/graphql',
  benefitsManager: process.env.VUE_APP_BENEFITS_MANAGER_HTTP || defaultFedGateway,
  consumer: process.env.VUE_APP_MICROSERVICES_CONSUMER || defaultFedGateway,
  storeEvents: process.env.VUE_APP_MICROSERVICES_STORE_EVENTS || defaultFedGateway,
}

export default {
  install(app) {
    app.config.globalProperties.$microservicesUrls = microservicesUrls
  },
}
